<div [formGroup]="form">
  <div class="section-container" id="totais">
    <div class="section-title">
      <mat-icon>calculate</mat-icon>
      <span>Totais</span>
    </div>
    <p class="text-muted small mb-3">Atualizados automaticamente em tempo real</p>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="card-total">
          <span class="card-total-label">Valor Total</span>
          <span class="card-total-value">{{ valorTotal | abnt:'preco':2 }}</span>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="card-total card-total-liquido">
          <span class="card-total-label">Valor Líquido a Pagar</span>
          <span class="card-total-value">{{ valorLiquido | abnt:'preco':2 }}</span>
          <span class="card-total-caption">Total – impostos retidos ({{ totalImpostosRetidos | abnt:'preco':2 }})</span>
        </div>
      </div>
    </div>
  </div>
</div>